import { render, staticRenderFns } from "./CookieAgreementPopup.vue?vue&type=template&id=24e89479&"
import script from "./CookieAgreementPopup.vue?vue&type=script&lang=js&"
export * from "./CookieAgreementPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports